export default {
  install: (Vue, { main, fallback }) => {
    Vue.callWithTheme = function (callback) {                   
      return async () => {
        try {
          return await callback(main);
        }
        catch (err) {
          console.error(err)
          if (fallback) {          
            return await callback(fallback);
          }
        }
      }
    };
    Vue.themeName = main;
  }
};


// WEBPACK FOOTER //
// ./_common/plugins/theme.plugin.js